// extracted by mini-css-extract-plugin
export default {"content":"AppShell_content__88eNl","brand":"AppShell_brand__9MMVV","rail":"AppShell_rail__CM56J","bar":"AppShell_bar__g3Yaw"};